import gql from 'graphql-tag';

export const WIND_PROJECT_QUERY = gql`
  query windProject($id: Int!) {
    featuredWindProject(id: $id) {
      id
      description
      imageUrl
      latitude
      location
      longitude
      name
      projectType
      state
      totalYearlyPowerProduced
      unitsPowered
      carbonEquivalency {
        totalCarbon
      }
    }
  }
`;

export const WindProjectMock = {
  featuredWindProject: {
    carbonEquivalency: {
      totalCarbon: 555,
    },
    description: 'The thing about this project is...',
    id: 1,
    imageUrl: 'https://myimageurl',
    latitude: 1234,
    location: 'Goldendale',
    longitude: 5678,
    name: 'Goodnoe Hills',
    projectType: 'wind',
    state: 'WA',
    totalYearlyPowerProduced: 564,
    unitsPowered: 144,
  },
};
